document.addEventListener('DOMContentLoaded', function() {
    const searchButtons = document.querySelectorAll('.search-button-desktop');
    const searchForms = document.querySelectorAll('.navbar-one__search-form');

    if (searchButtons.length > 0 && searchForms.length > 0) {
        // Toggle class on button click
        searchButtons.forEach((button, index) => {
            button.addEventListener('click', function(event) {
                event.stopPropagation(); // Prevent this click from immediately closing the form
                searchForms[index].classList.toggle('search-open');
            });
        });

        // Remove class when clicking outside the search areas
        document.addEventListener('click', function(event) {
            searchForms.forEach((form, index) => {
                if (!searchButtons[index].contains(event.target) && !form.contains(event.target)) {
                    form.classList.remove('search-open');
                }
            });
        });

        // Prevent the search forms from closing when clicking inside them
        searchForms.forEach(form => {
            form.addEventListener('click', function(event) {
                event.stopPropagation();
            });
        });
    }
});